import styled from "styled-components";
export const AccountName = styled.p.attrs({
  className: "text-2xl",
})`
  color: var(--lightgray);
  font-weight: 700;
`;

export const BigBoldText = styled.span`
  font-weight: 700;
  color: var(--dark);
`;

export const CarDGrid = styled.div.attrs({
  className: "",
})`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 1200px) {
    display: block;
  }
  @media screen and (max-width: 768px) {
    margin-top: 60px;
  }
`;

export const Icon = styled.div``;
interface ICard {
  onClick?: () => void;
}
export const Card = styled.div.attrs({
  className:
    "lg:mr-3 md:mr-3 sm:mr-0 mb-3 lg:w-full xl:w-1/3 md:w-full sm:w-full",
})<ICard>`
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  min-height: 100px;
  padding: 1.7rem;
  background-color: white;
  cursor: pointer;
  &:hover ${Icon} {
    cursor: pointer;
    transform: scale(1.3);
    opacity: 0.8;
    transition: all 0.3s ease-in-out;
  }
`;

export const GraphCard = styled.div.attrs({
  className: "mb-7 mt-7 flex flex-1 flex-col",
})`
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  padding: 25px 0px;
  background-color: var(--white);
  padding-left: 30px;
  padding-bottom: 70px;

  @media screen and (max-width: 768px) {
    margin-right: 0px;
    padding-left: 15px;
    min-height: fit-content;
    padding-bottom: 15px;
  }
`;

export const CardHeaderText = styled.span.attrs({
  className: "text-sm",
})`
  color: var(--lightgray);
  letter: 1px;
`;
export const BoldHeader = styled.span.attrs({
  className: `font-bold text-2xl`,
})``;
export const GraphGrid = styled.span.attrs({
  className: "mb-4",
})`
  display: flex;

  @media screen and (max-width: 1000px) {
    display: block;
  }
`;

export const TrendContainer = styled.div.attrs({
  className: "flex flex-col",
})`
  height: 370px;
  overflow-y: scroll;
  width: 100%;
  padding-right: 20px;
  margin-top: 10px;

  &::-webkit-scrollbar {
    width: 7px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px lightgray;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 7px;
  }
`;

export const PieWrapper = styled.div.attrs({
  className: "mt-7",
})`
  display: flex;
  width: 100%;
  height: 80%;

  @media screen and (max-width: 768px) {
    max-height: 300px;
  }
`;

export const LargeContainer = styled.div.attrs({
  className: "mb-7 px-5 py-10",
})`
  background-color: var(--white);
  /* border: 1px solid #e4e4e7; */
  border-radius: 10px;
`;

export const TableRow = styled.tr.attrs({
  className: " text-xs ",
})`
  background-color: var(--lightPurpleGrey);
  cursor: pointer;
  border: 8px solid white;
`;

export const TableWrapper = styled.div.attrs({
  className: "px-5 py-5",
})`
  border: 1px solid #ece6ee;
  border-radius: 0.8rem;
  @media screen and (max-width: 768px) {
    margin-top: 2rem;
  }
`;

export const PlainSelect = styled.select.attrs({ className: "rounded" })`
  border: 0;
  outline: 0;
  max-width: 10rem;
  background: unset;
  width: fit-content;
  width: max-content;
`;

export const ButtonSpan = styled.button.attrs({
  className: "cursor-pointer",
})`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: inherit;
`;
